import { __require as r } from "./Candidate.mjs";
import { __require as e } from "./Lookup.mjs";
import { __require as t } from "../Batch.mjs";
import { __require as s } from "../Errors.mjs";
import { __require as o } from "../util/sendBatch.mjs";
import { __require as i } from "../util/apiToSDKKeyMap.mjs";
var a, n;
function m() {
  if (n) return a;
  n = 1;
  const m = r(),
    u = e(),
    d = t(),
    _ = s().UndefinedLookupError,
    c = o(),
    f = i().usStreet;
  return a = class {
    constructor(r) {
      this.sender = r;
    }
    send(r) {
      const e = r instanceof u;
      if (!e && !(r instanceof d)) throw new _();
      let t;
      return e ? (null == r.maxCandidates && "enhanced" == r.match && (r.maxCandidates = 5), t = new d(), t.add(r)) : t = r, c(t, this.sender, m, f);
    }
  };
}
export { m as __require };